import api from './api';

export type Titulacao = 'graduacao' | 'pos_graduacao' | 'mestrado' | 'doutorado';

export interface Professor {
    user_id: number;
    nome: string;
    cpf?: string;
    email?: string;
    siape?: string;
    titulacao?: Titulacao | null;
    titulacao_label?: string | null;
    instituicao?: string;
    passaporte?: string;
    tipo?: 'interno' | 'externo';
    created_at?: string;
    updated_at?: string;
    cursos?: Array<{ codigo_sigaa: string; nome: string }>;
    cursos_coordenados?: Array<{ id: number; codigo_sigaa: string; nome: string; nivel: string }>;
    cursos_coordenador_tcc?: Array<{ id: number; codigo_sigaa: string; nome: string; nivel: string }>;
    cursos_secretaria?: Array<{ id: number; codigo_sigaa: string; nome: string; nivel: string }>;
    user?: {
        id: number;
        name: string;
        login: string;
    } | null;
}

interface ProfessorEditableFields {
    nome: string;
    cpf?: string;
    email: string;
    siape?: string;
    titulacao?: Titulacao | null;
    instituicao?: string;
    passaporte?: string;
    curso_codigos?: string[];
    send_password_setup_email?: boolean;
}

export interface CreateProfessorData extends ProfessorEditableFields {
    tipo: 'externo';
}

export type UpdateExternalProfessorData = ProfessorEditableFields;

export interface UpdateInternalProfessorData {
    curso_codigos?: string[];
}

export type UpdateProfessorData = UpdateExternalProfessorData | UpdateInternalProfessorData;
export type ProfessorFormData = CreateProfessorData | UpdateProfessorData;

export interface ProfessoresResponse {
    data: Professor[];
    meta?: {
        total: number;
        current_page: number;
        per_page: number;
    };
    total?: number;
}

export default {
    async getProfessores(params?: any) {
        return api.get<ProfessoresResponse>('/admin/professores', { params });
    },

    async getProfessor(id: number) {
        return api.get(`/admin/professores/${id}`);
    },

    async createProfessor(data: CreateProfessorData) {
        return api.post('/admin/professores', data);
    },

    async updateProfessor(id: number, data: UpdateProfessorData) {
        return api.put(`/admin/professores/${id}`, data);
    },

    async deleteProfessor(id: number) {
        return api.delete(`/admin/professores/${id}`);
    },

    async syncSigaa() {
        return api.post('/admin/professores/sync-sigaa');
    },

    async buscarProfessores(params?: any) {
        return api.get<ProfessoresResponse>('/coordenador/professores', { params });
    },

    async promoverCoordenador(id: number, cursosIds: number[], force = false) {
        return api.post(`/admin/professores/${id}/promover-coordenador`, { cursos: cursosIds, force });
    },

    async promoverCoordenadorTcc(id: number, cursosIds: number[], force = false) {
        return api.post(`/admin/professores/${id}/promover-coordenador-tcc`, { cursos: cursosIds, force });
    },

    async promoverSecretaria(id: number, cursosIds: number[], force = false) {
        return api.post(`/admin/professores/${id}/promover-secretaria`, { cursos: cursosIds, force });
    },

    async getMeusCursos() {
        return api.get('/professor/meus-cursos');
    }
};
